import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import moment, { utc } from 'moment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//services
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { HiringService } from 'src/app/pages/hiring/services/hiring.service';
import { HomeService } from 'src/app/pages/home/services/home.service';

@Component({
  selector: 'app-review-i9-modal',
  templateUrl: './review-i9-modal.component.html',
  styleUrls: ['./review-i9-modal.component.css']
})
export class ReviewI9ModalComponent implements OnInit {

  @ViewChild('I9Form', { static: false }) I9Form: NgForm;
  @ViewChild('signaturePadS2', { static: false }) signaturePadS2;
  @ViewChild('signaturePadS3', { static: false }) signaturePadS3;
  @Input() id: number;
  @Input() viewMode: boolean;
  @Input() isRehire: boolean;
  portalSettings: any;
  i9Section3Require: boolean;
  enableCheckboxSign: boolean;
  requireFirstWorkdateOnI9: boolean;
  formData: { [key: string]: any } = {};
  sign: { [key: string]: any } = {};
  date: { [key: string]: any } = {};
  formData2: { [key: string]: any } = {};
  sign2: { [key: string]: any } = {};
  date2: { [key: string]: any } = {};
  validateCheck: boolean = false;
  mobileMode: boolean;
  format: string;
  datePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean; adaptivePosition: boolean };
  documentTitleAList12: any[] = [];
  documentTitleAList3: any[] = [];
  documentTitleAList4: any[] = [];
  documentTitleListOri: any[] = [];
  documentTitleBList: any[] = [];
  documentTitleCList12: any[] = [];
  documentTitleCList34: any[] = [];
  stateList: any[];
  q4NA: boolean = false;
  documentTitleAList: any[];
  documentTitleCList: any[];
  alert: string;
  latitude: any;
  longitude: any;
  panelWidth: number;
  signEmporAuthS2RedBorder: boolean;
  signEmporAuthS3RedBorder: boolean;
  monthDateFormat: string = "MM/DD/YYYY";
  new2023: any;

  constructor(portalSettingsService: PortalSettingsService, private utilityService: UtilityService, private hiringService: HiringService, private activeModal: NgbActiveModal, private homeService: HomeService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.mobileMode = this.utilityService.isMobileMode();
  }

  ngOnInit(): void {
    this.new2023 = false;
    this.i9Section3Require = this.portalSettings.I9Section3Require.ConfigValue == "1";
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == "1" ? true : false;
    this.requireFirstWorkdateOnI9 = this.portalSettings.RequireFirstWorkdateOnI9.ConfigValue == "1";
    this.viewMode = this.viewMode == true ? true : false;

    this.format = this.utilityService.getDateFormat();
    this.datePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false, adaptivePosition: true };

    if (this.isRehire)
      this.date2.S3SignatureDate = new Date(moment().format(this.monthDateFormat));
    else
      this.date2.S2SignatureDate = new Date(moment().format(this.monthDateFormat));

    this.formData2.ListBDocumentTitle = null; this.formData2.ListBIssuingAuthority = null; this.formData2.ListBDocumentNumber = null;
    this.formData2.ListAExpirationDateStr = null; this.formData2.ListAExpirationDateStr2 = null; this.formData2.ListAExpirationDateStr3 = null; this.formData2.ListBExpirationDateStr = null; this.formData2.ListCExpirationDateStr = null; this.formData2.S2EmployeeFirstDayStr = null; this.formData2.S2SignatureDateStr = null; this.formData2.S3RehireDateStr = null; this.formData2.S3ExpirationDateStr = null;
    this.formData2.S3SignatureDateStr = null; this.formData2.S2SignatureTypeSign = null; this.formData2.S3SignatureTypeSign = null;
    this.formData2.S2SignatureBinary = null; this.formData2.S3SignatureBinary = null;
    this.date2.ListBExpirationDate = null;
    this.formData2.ListCDocumentTitle = null; this.formData2.ListCIssuingAuthority = null; this.formData2.ListCDocumentNumber = null; this.date2.ListCExpirationDate = null;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
      });
    }

    this.documentTitleAList12.push({ name: "", value: '' });
    this.documentTitleAList12.push({ name: "U.S. Passport", value: "U.S. Passport" });
    this.documentTitleAList12.push({ name: "U.S. Passport Card", value: "U.S. Passport Card" });

    this.documentTitleAList3.push({ name: "", value: '' });
    this.documentTitleAList3.push({ name: "Perm. Resident Card (Form I-551)", value: "Perm. Resident Card (Form I-551)" });
    this.documentTitleAList3.push({ name: "Alien Reg. Receipt Card (Form I-551)", value: "Alien Reg. Receipt Card (Form I-551)" });
    this.documentTitleAList3.push({ name: "Foreign Passport with Temp. I-551 Stamp", value: "Foreign Passport with Temp. I-551 Stamp" });
    this.documentTitleAList3.push({ name: "Foreign Passport with Temp. I-551 MRIV", value: "Foreign Passport with Temp. I-551 MRIV" });
    this.documentTitleAList3.push({ name: "Receipt: Form I-94/I-94A w/I-551 stamp, photo", value: "Receipt: Form I-94/I-94A w/I-551 stamp, photo" });
    this.documentTitleAList3.push({ name: "Receipt: Replacement Perm. Res. Card (Form I-551)", value: "Receipt: Replacement Perm. Res. Card (Form I-551)" });

    this.documentTitleAList4.push({ name: "", value: '' });
    this.documentTitleAList4.push({ name: "Employment Auth. Document (Form I-766)", value: "Employment Auth. Document (Form I-766)" });
    this.documentTitleAList4.push({ name: "Foreign Passport, work-authorized nonimmigrant", value: "Foreign Passport, work-authorized nonimmigrant" });
    this.documentTitleAList4.push({ name: "FSM Passport with Form I-94", value: "FSM Passport with Form I-94" });
    this.documentTitleAList4.push({ name: "RMI Passport with Form I-94", value: "RMI Passport with Form I-94" });
    this.documentTitleAList4.push({ name: "Receipt: Replacement EAD (Form I-766)", value: "Receipt: Replacement EAD (Form I-766)" });
    this.documentTitleAList4.push({ name: "Receipt: Form I-94/I-94A w/refugee stamp (or RE class of admission)", value: "Receipt: Form I-94/I-94A w/refugee stamp (or RE class of admission)" });
    this.documentTitleAList4.push({ name: "Receipt: Foreign Passport, work-authorized nonimmigrant", value: "Receipt: Foreign Passport, work-authorized nonimmigrant" });
    this.documentTitleAList4.push({ name: "Receipt: FSM Passport with Form I-94", value: "Receipt: FSM Passport with Form I-94" });
    this.documentTitleAList4.push({ name: "Receipt: RMI Passport with Form I-94", value: "Receipt: RMI Passport with Form I-94" });
    this.documentTitleAList4.push({ name: "Student Form I-20", value: "Student Form I-20" });

    this.documentTitleListOri.push({ name: "", value: '' });
    this.documentTitleListOri.push({ name: "U.S. Passport", value: "U.S. Passport" });
    this.documentTitleListOri.push({ name: "U.S. Passport Card", value: "U.S. Passport Card" });
    this.documentTitleListOri.push({ name: "Perm. Resident Card (Form I-551)", value: "Perm. Resident Card (Form I-551)" });
    this.documentTitleListOri.push({ name: "Alien Reg. Receipt Card (Form I-551)", value: "Alien Reg. Receipt Card (Form I-551)" });
    this.documentTitleListOri.push({ name: "Foreign Passport with Temp. I-551 Stamp", value: "Foreign Passport with Temp. I-551 Stamp" });
    this.documentTitleListOri.push({ name: "Foreign Passport with Temp. I-551 MRIV", value: "Foreign Passport with Temp. I-551 MRIV" });
    this.documentTitleListOri.push({ name: "Employment Auth. Document (Form I-766)", value: "Employment Auth. Document (Form I-766)" });
    this.documentTitleListOri.push({ name: "Foreign Passport with Form I-94, endorsement", value: "Foreign Passport with Form I-94, endorsement" });
    this.documentTitleListOri.push({ name: "FSM Passport with Form I-94", value: "FSM Passport with Form I-94" });
    this.documentTitleListOri.push({ name: "RMI Passport with Form I-94", value: "RMI Passport with Form I-94" });
    this.documentTitleListOri.push({ name: "Receipt: Form I-94/I-94A w/I-551 stamp, photo", value: "Receipt: Form I-94/I-94A w/I-551 stamp, photo" });
    this.documentTitleListOri.push({ name: "Receipt: Form I-94/I-94A w/refugee stamp (or RE class of admission)", value: "Receipt: Form I-94/I-94A w/refugee stamp (or RE class of admission)" });
    this.documentTitleListOri.push({ name: "Social Security Card (Unrestricted)", value: "Social Security Card (Unrestricted)" });
    this.documentTitleListOri.push({ name: "Form FS-545", value: "Form FS-545" });
    this.documentTitleListOri.push({ name: "Form FS-240", value: "Form FS-240" });
    this.documentTitleListOri.push({ name: "Form DS-1350", value: "Form DS-1350" });
    this.documentTitleListOri.push({ name: "U.S. Birth certificate", value: "U.S. Birth certificate" });
    this.documentTitleListOri.push({ name: "Native American Tribal document", value: "Native American Tribal document" });
    this.documentTitleListOri.push({ name: "Form I-197", value: "Form I-197" });
    this.documentTitleListOri.push({ name: "Form I-179", value: "Form I-179" });
    this.documentTitleListOri.push({ name: "Employment auth. document (DHS)", value: "Employment auth. document (DHS)" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Perm. Res. Card (Form I-551)", value: "Receipt: Replacement Perm. Res. Card (Form I-551)" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Employment Auth. Document (Form I-766)", value: "Receipt: Replacement Employment Auth. Document (Form I-766)" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Foreign Passport with Form I-94 , endorsement", value: "Receipt: Replacement Foreign Passport with Form I-94 , endorsement" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement FSM passport/Form I-94", value: "Receipt: Replacement FSM passport/Form I-94" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement RMI passport/Form I-94", value: "Receipt: Replacement RMI passport/Form I-94" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Social Security Card", value: "Receipt: Replacement Social Security Card" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Birth Certificate", value: "Receipt: Replacement Birth Certificate" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Native American Tribal Document", value: "Receipt: Replacement Native American Tribal Document" });
    this.documentTitleListOri.push({ name: "Receipt: Replacement Employment Auth. Doc (DHS)", value: "Receipt: Replacement Employment Auth. Doc (DHS)" });

    this.documentTitleBList.push({ name: "", value: '' });
    this.documentTitleBList.push({ name: "Driver's License issued by state/territory", value: "Driver's License issued by state/territory" });
    this.documentTitleBList.push({ name: "ID card issued by state/territory", value: "ID card issued by state/territory" });
    this.documentTitleBList.push({ name: "Government ID", value: "Government ID" });
    this.documentTitleBList.push({ name: "School ID", value: "School ID" });
    this.documentTitleBList.push({ name: "Voter registration card", value: "Voter registration card" });
    this.documentTitleBList.push({ name: "U.S. Military card", value: "U.S. Military card" });
    this.documentTitleBList.push({ name: "U.S. Military draft record", value: "U.S. Military draft record" });
    this.documentTitleBList.push({ name: "Military dependent's ID card", value: "Military dependent's ID card" });
    this.documentTitleBList.push({ name: "USCG Merchant Mariner card", value: "USCG Merchant Mariner card" });
    this.documentTitleBList.push({ name: "Native American tribal document", value: "Native American tribal document" });
    this.documentTitleBList.push({ name: "Canadian driver's license", value: "Canadian driver's license" });
    this.documentTitleBList.push({ name: "School record (under age 18)", value: "School record (under age 18)" });
    this.documentTitleBList.push({ name: "Report card (under age 18)", value: "Report card (under age 18)" });
    this.documentTitleBList.push({ name: "Clinic record (under age 18)", value: "Clinic record (under age 18)" });
    this.documentTitleBList.push({ name: "Doctor record (under age 18)", value: "Doctor record (under age 18)" });
    this.documentTitleBList.push({ name: "Hospital record (under age 18)", value: "Hospital record (under age 18)" });
    this.documentTitleBList.push({ name: "Day-care record (under age 18)", value: "Day-care record (under age 18)" });
    this.documentTitleBList.push({ name: "Nursery School record (under age 18)", value: "Nursery School record (under age 18)" });
    this.documentTitleBList.push({ name: "Individual under Age 18", value: "Individual under Age 18" });
    this.documentTitleBList.push({ name: "Special Placement", value: "Special Placement" });
    this.documentTitleBList.push({ name: "Receipt Replacement Driver's License", value: "Receipt Replacement Driver's License" });
    this.documentTitleBList.push({ name: "Receipt Replacement ID Card", value: "Receipt Replacement ID Card" });
    this.documentTitleBList.push({ name: "Receipt Replacement Government ID", value: "Receipt Replacement Government ID" });
    this.documentTitleBList.push({ name: "Receipt Replacement School ID", value: "Receipt Replacement School ID" });
    this.documentTitleBList.push({ name: "Receipt Replacement Voter Reg. Card", value: "Receipt Replacement Voter Reg. Card" });
    this.documentTitleBList.push({ name: "Receipt Replacement U.S. Military card", value: "Receipt Replacement U.S. Military card" });
    this.documentTitleBList.push({ name: "Receipt Replacement Military Draft Record", value: "Receipt Replacement Military Draft Record" });
    this.documentTitleBList.push({ name: "Receipt Replacement Military Dep. Card", value: "Receipt Replacement Military Dep. Card" });
    this.documentTitleBList.push({ name: "Receipt Replacement Merchant Mariner Card", value: "Receipt Replacement Merchant Mariner Card" });
    this.documentTitleBList.push({ name: "Receipt Replacement Native American Tribal Doc", value: "Receipt Replacement Native American Tribal Doc" });
    this.documentTitleBList.push({ name: "Receipt Replacement Canadian DL.", value: "Receipt Replacement Canadian DL." });
    this.documentTitleBList.push({ name: "Receipt Replacement School Record (under age 18)", value: "Receipt Replacement School Record (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replacement Report Card (under age 18)", value: "Receipt Replacement Report Card (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replacement Clinic Record (under age 18)", value: "Receipt Replacement Clinic Record (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replacement Doctor Record (under age 18)", value: "Receipt Replacement Doctor Record (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replace. Hospital Record (under age 18)", value: "Receipt Replace. Hospital Record (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replace. Day-Care Record (under age 18)", value: "Receipt Replace. Day-Care Record (under age 18)" });
    this.documentTitleBList.push({ name: "Receipt Replace. Nursery School Record (under age 18)", value: "Receipt Replace. Nursery School Record (under age 18)" });

    this.documentTitleCList12.push({ name: "", value: '' });
    this.documentTitleCList12.push({ name: "Social Security Card (Unrestricted)", value: "Social Security Card (Unrestricted)" });
    this.documentTitleCList12.push({ name: "Form FS-545", value: "Form FS-545" });
    this.documentTitleCList12.push({ name: "Form FS-240", value: "Form FS-240" });
    this.documentTitleCList12.push({ name: "Form DS-1350", value: "Form DS-1350" });
    this.documentTitleCList12.push({ name: "U.S. Birth certificate", value: "U.S. Birth certificate" });
    this.documentTitleCList12.push({ name: "Native American tribal document", value: "Native American tribal document" });
    this.documentTitleCList12.push({ name: "Form I-197", value: "Form I-197" });
    this.documentTitleCList12.push({ name: "Form I-179", value: "Form I-179" });
    this.documentTitleCList12.push({ name: "Employment auth. document (DHS)", value: "Employment auth. document (DHS)" });
    this.documentTitleCList12.push({ name: "Receipt Replace. Unrestricted SS Card", value: "Receipt Replace. Unrestricted SS Card" });
    this.documentTitleCList12.push({ name: "Receipt Replacement Birth Certificate", value: "Receipt Replacement Birth Certificate" });
    this.documentTitleCList12.push({ name: "Receipt Replace. Native American Tribal Doc.", value: "Receipt Replace. Native American Tribal Doc." });
    this.documentTitleCList12.push({ name: "Receipt Replace. Employment Auth. Doc (DHS)", value: "Receipt Replace. Employment Auth. Doc (DHS)" });

    this.documentTitleCList34.push({ name: "", value: '' });
    this.documentTitleCList34.push({ name: "Social Security Card (Unrestricted)", value: "Social Security Card (Unrestricted)" });
    this.documentTitleCList34.push({ name: "Native American tribal document", value: "Native American tribal document" });
    this.documentTitleCList34.push({ name: "Employment auth. document (DHS)", value: "Employment auth. document (DHS)" });
    this.documentTitleCList34.push({ name: "Receipt Replace. Unrestricted SS Card", value: "Receipt Replace. Unrestricted SS Card" });
    this.documentTitleCList34.push({ name: "Receipt Replace. Native American Tribal Doc.", value: "Receipt Replace. Native American Tribal Doc." });
    this.documentTitleCList34.push({ name: "Receipt Replace. Employment Auth. Doc (DHS)", value: "Receipt Replace. Employment Auth. Doc (DHS)" });

    this.getDependentLookupByColumnName();
    this.getI9ByOnboardID();
    this.oNGetI9ByOnboardIDStep2();
  }

  getDependentLookupByColumnName() {
    this.hiringService.getDependentLookupByColumnName("State", null).then((response: any) => {
      this.stateList = response;
    });
  }

  getI9ByOnboardID() {
    this.hiringService.getI9ByOnboardID(this.id, 2).then((response: any) => {
      if (response.length > 0) {
        for (var [key, val] of Object.entries(response[0])) {
          if (key == "IsPreparerUsed") {
            if (val != null) {
              this.formData.IsPreparerUsedYN = val ? "Y" : "N";
            }
          } else if (key == "S1BirthDate") {
            if (val != null) {
              this.date.S1BirthDate = new Date(moment(val).utc().format(this.monthDateFormat));
            }
          } else if (key == "S1AlienExpiration") {
            if (val != null) {
              this.date.S1AlienExpiration = new Date(moment(val).utc().format(this.monthDateFormat));
            }
          } else if (key == "S1SignatureDate") {
            if (val != null) {
              this.date.S1SignatureDate = new Date(moment(val).utc().format(this.monthDateFormat));
              if ((new Date(parseInt(moment(val).utc().format("YYYY"))
                , parseInt(moment(val).utc().format("MM")) - 1
                , parseInt(moment(val).utc().format("DD")), 0, 0, 0, 0)) >= (new Date("2023/10/4")))
                this.new2023 = true;
            } else {
              if ((new Date()) >= (new Date("2023/10/4")))
                this.new2023 = true;
            }
          } else if (key == "PreparerSignatureDate") {
            if (val != null) {
              this.date.PreparerSignatureDate = new Date(moment(val).utc().format(this.monthDateFormat));
            }
          } else if (key == "S1SignatureBinary") {
            if (val != null) {
              this.sign.signEmployeesubmitSignImg = "data:image/png;base64," + (val);
            }
          } else if (key == "PreparerSignatureBinary") {
            if (val != null) {
              this.sign.signPreorTransubmitSignImg = "data:image/png;base64," + (val);
            }
          }
          else {
            this.formData[key] = val;
          }
        }

        if (this.formData.IsPreparerUsedYN == "Y" && this.new2023) {
          this.formData.PreparerList = [];
          this.hiringService.onboardI9GetSupA(this.id).then((response: any) => {
            response.forEach((val: any) => {
              this.formData.PreparerList.push({
                PreparerSignatureDate: new Date(moment(val.Date).utc().format("MM/DD/YYYY")), PreparerLastName: val.LastName, PreparerFirstName: val.FirstName, PreparerMiddleInitial: val.MiddleInitial, PreparerAddress: val.Address, PreparerCity: val.City,
                PreparerState: val.State, PreparerZip: val.ZipCode,
                signPreorTransubmitSignImg: (val.PreparerSignature != null ? "data:image/png;base64," + (val.PreparerSignature) : null), seq: val.Seq
              })
            })
          });
        }

        this.formData2.S2EmpLastName = this.formData.S1LastName;
        this.formData2.S2EmpFirstName = this.formData.S1FirstName;
        this.formData2.S2EmpMiddleName = this.formData.S1MiddleInitial;
        this.formData2.S2EmpCitizenStatus = this.formData.S1CitizenStatus;

        if (this.formData.S1CitizenStatus == 4 && this.date.S1AlienExpiration == null) {
          this.q4NA = true;
        }

        if (this.formData.S1CitizenStatus == 1 || this.formData.S1CitizenStatus == 2) {
          this.documentTitleAList = this.documentTitleAList12;
          this.documentTitleCList = this.documentTitleCList12;
        } else if (this.formData.S1CitizenStatus == 3) {
          this.documentTitleAList = this.documentTitleAList3;
          this.documentTitleCList = this.documentTitleCList34;
        } else if (this.formData.S1CitizenStatus == 4) {
          this.documentTitleAList = this.documentTitleAList4;
          this.documentTitleCList = this.documentTitleCList34;
        }
      }
    });
  }

  oNGetI9ByOnboardIDStep2() {
    this.hiringService.oNGetI9ByOnboardIDStep2(this.id).then((response: any) => {
      if (response.length > 0) {
        for (const [key, val] of Object.entries(response[0])) {
          if (key == "ListAExpirationDate") {
            if (val != null) {
              this.date2.ListAExpirationDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "ListAExpirationDate2") {
            if (val != null) {
              this.date2.ListAExpirationDate2 = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "ListAExpirationDate3") {
            if (val != null) {
              this.date2.ListAExpirationDate3 = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "ListBExpirationDate") {
            if (val != null) {
              this.date2.ListBExpirationDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "ListCExpirationDate") {
            if (val != null) {
              this.date2.ListCExpirationDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S2EmployeeFirstDay") {
            if (val != null) {
              this.date2.S2EmployeeFirstDay = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S2SignatureDate") {
            if (val != null) {
              this.date2.S2SignatureDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S3ExpirationDate") {
            if (val != null) {
              this.date2.S3ExpirationDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S3RehireDate") {
            if (val != null) {
              this.date2.S3RehireDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S3SignatureDate") {
            if (val != null) {
              this.date2.S3SignatureDate = new Date(moment(val, this.format.toUpperCase()).utc().format(this.monthDateFormat));
            }
          } else if (key == "S2SignatureBinary" && this.viewMode) {
            if (val != null) {
              this.sign2.signEmporAuthS2submitSignImg = "data:image/png;base64," + (val);
            }
          } else if (key == "S3SignatureBinary" && this.viewMode) {
            if (val != null) {
              this.sign2.signEmporAuthS3submitSignImg = "data:image/png;base64," + (val);
            }
          } else if (key != "S2SignatureBinary" && key != "S3SignatureBinary") {
            this.formData2[key] = val;
          }
        }

        this.date2.ListAExpirationDateinvalid = false;
        this.date2.ListAExpirationDateinvalid2 = false;
        this.date2.ListAExpirationDateinvalid3 = false;
        this.date2.ListBExpirationDateinvalid = false;
        this.date2.ListCExpirationDateinvalid = false;
      }
    });
  }

  checkDate(date: any, name: string) {
    var todayDate = new Date();
    if (date != null) {
      if ((date / 1) < todayDate.setHours(0, 0, 0, 0) / 1) {
        this.date2[name + "invalid"] = true;
      } else {
        this.date2[name + "invalid"] = false;
      }
    }
    else {
      this.date2[name + "invalid"] = false;
    }
  }

  saveI9() {
    this.validateCheck = true;
    this.checkSigned();
    if (!this.I9Form.form.invalid && !this.formData2.S2BusinessAddressInvalid) {
      this.alert = null;
      if (((this.sign2.signEmporAuthS2NotEmpty && !this.isRehire) ||
        (this.isRehire && ((this.i9Section3Require && this.sign2.signEmporAuthS3NotEmpty) || (!this.i9Section3Require && (this.sign2.signEmporAuthS2NotEmpty || this.sign2.signEmporAuthS3NotEmpty)))))
        && !this.date2.ListAExpirationDateinvalid && !this.date2.ListAExpirationDateinvalid2 && !this.date2.ListAExpirationDateinvalid3 && !this.date2.ListBExpirationDateinvalid && !this.date2.ListCExpirationDateinvalid) {

        this.formData2.OnboardID = this.id;


        if (this.date2.ListAExpirationDate != null) {
          this.formData2.ListAExpirationDateStr = moment(this.date2.ListAExpirationDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.ListAExpirationDate2 != null) {
          this.formData2.ListAExpirationDateStr2 = moment(this.date2.ListAExpirationDate2).utc().format(this.monthDateFormat);
        }
        if (this.date2.ListAExpirationDate3 != null) {
          this.formData2.ListAExpirationDateStr3 = moment(this.date2.ListAExpirationDate3).utc().format(this.monthDateFormat);
        }
        if (this.date2.ListBExpirationDate != null) {
          this.formData2.ListBExpirationDateStr = moment(this.date2.ListBExpirationDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.ListCExpirationDate != null) {
          this.formData2.ListCExpirationDateStr = moment(this.date2.ListCExpirationDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.S2EmployeeFirstDay != null) {
          this.formData2.S2EmployeeFirstDayStr = moment(this.date2.S2EmployeeFirstDay).utc().format(this.monthDateFormat);
        }
        if (this.date2.S2SignatureDate != null) {
          this.formData2.S2SignatureDateStr = moment(this.date2.S2SignatureDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.S3RehireDate != null) {
          this.formData2.S3RehireDateStr = moment(this.date2.S3RehireDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.S3ExpirationDate != null) {
          this.formData2.S3ExpirationDateStr = moment(this.date2.S3ExpirationDate).utc().format(this.monthDateFormat);
        }
        if (this.date2.S3SignatureDate != null) {
          this.formData2.S3SignatureDateStr = moment(this.date2.S3SignatureDate).utc().format(this.monthDateFormat);
        }

        if (this.sign2.signEmporAuthS2typeSign) { // need to remove
          this.formData2.S2SignatureBinary = this.sign2.signEmporAuthS2rawImgData;
        } else {
          if (this.formData2.S2SignatureBinary == null)
            this.formData2.S2SignatureBinary = this.signaturePadS2.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "");
        }

        if (this.isRehire) {
          if (this.sign2.signEmporAuthS3rawImgData) {  // need to remove
            this.formData2.S3SignatureBinary = this.sign2.signEmporAuthS3rawImgData;
          } else {
            if (this.formData2.S3SignatureBinary == null)
              this.formData2.S3SignatureBinary = this.signaturePadS3.toDataURL().replace(/^data:image\/(png|jpg);base64,/, "");
          }
        }

        if (this.longitude != null)
          this.formData2.longitude = this.longitude;
        if (this.latitude != null)
          this.formData2.latitude = this.latitude;

        for (let [key, value] of Object.entries(this.formData2)) {
          if (value == "") {
            this.formData2[key] = null;
          }
        }
        this.hiringService.updateI9ByOnboardIDPart2(this.formData2).then((response: any) => {
          this.validateCheck = false;
          if (response.success) {
            this.activeModal.close("success");
          } else {
            this.alert = response.error;
          }
        });
      } else {
        this.alert = "Please fill out or correct all required fields.";
      }
    } else {
      this.alert = "Please fill out or correct all required fields. ";
    }
  }

  checkAddress(parmName: string) {
    var regex = /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i;
    var match = regex.exec(this.formData2[parmName]);
    if (match != null) {
      this.formData2[parmName + "Invalid"] = true;
    } else {
      this.formData2[parmName + "Invalid"] = false;
    }
  }

  closeClick() {
    this.activeModal.dismiss();
  }

  getTypeSign(type: string, name: string) {
    this.sign2[name + "typeSign"] = true;
    this.homeService.getTypeSign(type).then((response: any) => {
      this.sign2[name + "rawImgData"] = response;
      this.sign2[name + "submitSignImg"] = "data:image/png;base64," + response;
      this.sign2[name + "NotEmpty"] = true;
      this.sign2[name + "hideClick"] = true;
    });
    this.sign2[name + "showClickMsg"] = false;
  }

  clickSign(type: string, name: string) {
    if (name == "signEmporAuthS2") {
      if (this.signaturePadS2.isEmpty()) {
        this.getTypeSign(type, name);
      } else {
        this.sign2[name + "showClickMsg"] = true;
      }
    }
    else if (name == "signEmporAuthS3") {
      if (this.signaturePadS3.isEmpty()) {
        this.getTypeSign(type, name);
      } else {
        this.sign2[name + "showClickMsg"] = true;
      }
    }
  }

  checkSigned() {
    if (this.isRehire) {
      if (this.signaturePadS3 != null) {
        if (this.signaturePadS3.isEmpty() == false) {
          this.sign2.signEmporAuthS3NotEmpty = true;
          this.signEmporAuthS3RedBorder = false;
        } else {
          this.signEmporAuthS3RedBorder = true;
        }
      }

      if (this.signaturePadS2 != null) {
        if (this.signaturePadS2.isEmpty() == false) {
          this.sign2.signEmporAuthS2NotEmpty = true;
          this.signEmporAuthS2RedBorder = false;
        } else {
          this.signEmporAuthS2RedBorder = true;
        }
      }
    } else if (!this.isRehire) {
      if (this.signaturePadS2 != null) {
        if (this.signaturePadS2.isEmpty() == false) {
          this.sign2.signEmporAuthS2NotEmpty = true;
          this.signEmporAuthS2RedBorder = false;
        } else {
          this.signEmporAuthS2RedBorder = true;
        }
      }
    }
  }

  clear(name: string) {
    if (name == "signEmporAuthS3" && this.signaturePadS3 != null) {
      this.signaturePadS3.clear();
    }
    else if (name == "signEmporAuthS2" && this.signaturePadS2 != null) {
      this.signaturePadS2.clear();

    }
    this.sign2[name + "NotEmpty"] = false;
    this.sign2[name + "rawImgData"] = null;
    this.sign2[name + "submitSignImg"] = null;
    this.sign2[name + "typeSign"] = false;
    this.sign2[name + "showClickMsg"] = false;
    this.sign2[name + "hideClick"] = false;
    this.sign2[name + "showClickMsg"] = false;
  }

  base64ArrayBuffer(arrayBuffer: any) {
    var base64 = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes = new Uint8Array(arrayBuffer)
    var byteLength = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
      d = chunk & 63               // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength]

      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4 // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2 // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
  }

  updateSZip(data: string) {
    this.formData.S1Zip = data;
  }

  updatePZip(data: string) {
    this.formData.PreparerZip = data;
  }

  updateS2Zip(data: string) {
    this.formData2.S2Zip = data;
  }
}
